import { gql } from "@apollo/client";

export const USER_FIELDS = gql`
  fragment UserFields on User {
    fullName
    email
    id
    createdAt
    tenantRole
    language
  }
`;

export const USER_INVITE_FIELDS = gql`
  fragment UserInviteFields on UserInvite {
    fullName
    email
    id
    createdAt
    tenantRole
  }
`;

export const EDIT_OWN_PROFILE = gql`
  ${USER_FIELDS}
  mutation EditOwnProfile($input: EditOwnProfileInput!) {
    editOwnProfile(input: $input) {
      ...UserFields
    }
  }
`;

export const LIST_SUBACCOUNT_USERS = gql`
  ${USER_FIELDS}
  query ListSubaccountUsers(
    $input: ListSubaccountUsersInput!
    $subaccountId: String!
  ) {
    listSubaccountUsers(input: $input) {
      users {
        ...UserFields
        subaccountMemberships(subaccountId: $subaccountId) {
          id
          role
        }
      }
      totalCount
    }
  }
`;

export const LIST_SUBACCOUNT_USER_INVITES = gql`
  ${USER_INVITE_FIELDS}
  query ListSubaccountUserInvites(
    $input: ListSubaccountUserInvitesInput!
    $subaccountId: String!
  ) {
    listSubaccountUserInvites(input: $input) {
      userInvites {
        ...UserInviteFields
        subaccountMemberships(subaccountId: $subaccountId) {
          id
          role
        }
      }
      totalCount
    }
  }
`;

export const LIST_TENANT_USERS = gql`
  ${USER_FIELDS}
  query ListTenantUsers($input: ListTenantUsersInput!) {
    listTenantUsers(input: $input) {
      users {
        ...UserFields
        subaccountMemberships {
          id
          role
          subaccount {
            id
            name
            slug
          }
        }
      }
      totalCount
    }
  }
`;

export const LIST_TENANT_USER_INVITES = gql`
  ${USER_INVITE_FIELDS}
  query ListTenantUserInvites($input: ListTenantUserInvitesInput!) {
    listTenantUserInvites(input: $input) {
      userInvites {
        ...UserInviteFields
        subaccountMemberships {
          id
          role
          subaccount {
            id
            name
            slug
          }
        }
      }
      totalCount
    }
  }
`;

export const AUTOCOMPLETE_SUBACCOUNT_USER_SEARCH = gql`
  query AutocompleteSubaccountUserSearch(
    $subaccountId: String!
    $search: UserFilterInput!
  ) {
    listSubaccountUsers(
      input: {
        subaccountId: $subaccountId
        filter: $search
        limit: 8
        offset: 0
        sort: FULL_NAME_ASC
      }
    ) {
      users {
        id
        fullName
      }
    }
  }
`;

export const CREATE_SUBACCOUNT_USER_INVITE = gql`
  ${USER_FIELDS}
  ${USER_INVITE_FIELDS}
  mutation CreateSubaccountUserInvite(
    $input: CreateSubaccountUserInviteInput!
  ) {
    createSubaccountUserInvite(input: $input) {
      user {
        ...UserFields
      }
      userInvite {
        ...UserInviteFields
      }
    }
  }
`;

export const CREATE_SUBACCOUNT_USER_INVITES = gql`
  mutation CreateSubaccountUserInvites(
    $input: CreateSubaccountUserInvitesInput!
  ) {
    createSubaccountUserInvites(input: $input) {
      nSuccess
      nFailed
      roleExists
      inviteExists
    }
  }
`;

export const REVOKE_SUBACCOUNT_USER_INVITE = gql`
  mutation RevokeSubaccountUserInvite(
    $input: RevokeSubaccountUserInviteInput!
  ) {
    revokeSubaccountUserInvite(input: $input) {
      success
    }
  }
`;

export const CREATE_TENANT_USER_INVITE = gql`
  ${USER_FIELDS}
  ${USER_INVITE_FIELDS}
  mutation CreateTenantUserInvite($input: CreateTenantUserInviteInput!) {
    createTenantUserInvite(input: $input) {
      user {
        ...UserFields
      }
      userInvite {
        ...UserInviteFields
      }
    }
  }
`;

export const CREATE_TENANT_USER_INVITES = gql`
  mutation CreateTenantUserInvites($input: CreateTenantUserInvitesInput!) {
    createTenantUserInvites(input: $input) {
      nSuccess
      nFailed
      roleExists
      inviteExists
    }
  }
`;

export const REVOKE_TENANT_USER_INVITE = gql`
  mutation RevokeTenantUserInvite($input: RevokeTenantUserInviteInput!) {
    revokeTenantUserInvite(input: $input) {
      success
    }
  }
`;

export const DEACTIVATE_USER = gql`
  mutation DeactivateUser($input: DeactivateUserInput!) {
    deactivateUser(input: $input) {
      success
    }
  }
`;

export const REMOVE_USER_FROM_SUBACCOUNT = gql`
  mutation RemoveUserFromSubaccount($input: RemoveUserFromSubaccountInput!) {
    removeUserFromSubaccount(input: $input) {
      success
    }
  }
`;

export const UPDATE_USER_SUBACCOUNT_ROLE = gql`
  ${USER_FIELDS}
  mutation UpdateUserSubaccountRole($input: UpdateUserSubaccountRoleInput!) {
    updateUserSubaccountRole(input: $input) {
      ...UserFields
    }
  }
`;

export const GET_TEXTER_NAMES = gql`
  query getTexterNames(
    $subaccountId: String!
    $texterIds: [String!]!
    $limit: Int!
  ) {
    listSubaccountUsers(
      input: {
        filter: { idIn: $texterIds }
        limit: $limit
        sort: CREATED_AT_ASC
        subaccountId: $subaccountId
      }
    ) {
      users {
        id
        fullName
      }
    }
  }
`;
